const teccom = {
  steps: {
    select: 'Seleziona i fornitori',
    order: 'Seleziona ordine',
    order_details: 'Dettagli ordine',
    send: 'Ordina',
  },
  supplier_select: 'Seleziona fornitore',
  download: 'Invia ordine',
  supplier_id: 'Fornitore',
  codice_magazzino: 'Magazzino',
  tof_codfor: 'Fornitore',
  tof_mag: 'Codice magazzino',
  tof_anno: 'Anno',
  tof_progr: 'Progressivo',
  tof_datord: 'Data',
  tof_tipord: 'Tipo',
  tof_cod_dest: 'Destinazione',
  tof_user_cod: 'Utente',
  fk_cod_for_cati: 'Codice fornitore CATI',
  stato: 'Stato',
  for_rag_soc_1: 'Nome fornitore',
  dof_codmag: 'Codice prodotto',
  mag_descr: 'Descrizione prodotto',
  dof_datsca: 'Scadenza ordine',
  dof_voce: 'Progressivo voce',
  dof_codiva_cog: 'Cod. IVA',
  dof_ord: 'Qta. Ord.',
  dof_riscontrata: 'Qta. riscontrata',
  dof_cons: 'Qta. consegnata',
  dof_costo: 'Costo',
  dof_sc: 'Sconto',
  supplier_details_text: 'Ordine per:',
  supplier_name: 'Nome fornitore',
  order_details: 'Dettagli ordine',
  num_items: 'Numero prodotti',
  total_amount_ordered: 'Quantita totale pezzi',
  total_expence: 'Importo totale',
  payment: 'Modalita di pagamento',
  address: 'Spedito a',
  courier: 'Corriere',
  back_to_home_button: 'Torna alla selezione ordini',
  status_code: 'Codice stato',
  status_message: 'Esito',
  status: 'Stato',
  guid: 'Codice transazione',
  datetime: 'Data e ora',
  citta_magazzino: 'Citta',
  tracked_status: 'Ordine registrato',
  message: 'Esiti invio ordini',
  order_resume: 'Riassunto ordini',
  tof_datcons: 'Data consegna',
  tof_datcons_placeholder: 'Cambia data consegna',
  ord_progr: 'Progressivi ordine',
  order_kind: 'Tipo ordine',
  delivery_config: 'Configurazione consegna',
  batch_id: 'Numero batch',
  job_data: 'Dati lavoro',
  id: 'ID',
  order_suffix: 'Suffisso ordine',
  order_suffix_placeholder: 'Suffisso',
  documents: {
    // Filtri
    document_id: 'Numero documento',
    seller_party_number: 'Fornitore TecCom',
    seller_party_number_hint:
      'Numero fornitore riportato sul documento: scegli fra quelli in elenco o digitalo e premi Invio',
    date_from: 'Dal',
    date_to: 'Al',

    // Colonne / campi della testata
    columns: {
      document_id: 'N. documento',
      issue_date: 'Data documento',
      delivery_date: 'Data consegna',
      dispatch_date: 'Data spedizione',
      order_date: 'Data ordine',
      seller_name: 'Fornitore',
      delivery_name: 'Destinazione merce',
      seller_order_number: 'Ordine fornitore',
      buyer_order_number: 'Ordine CATI',
      transport_means: 'Corriere',
      message_status: 'Stato messaggio',
      source_version: 'Versione documento',
      versions_count: 'Versioni',
      received_at: 'Ricevuto il',
      ftp_written_at: 'Scritto su FTP il',
      account_id: 'Account TecCom',
      actions: 'Azioni',
    },

    // Azioni di riga
    details: 'Dettaglio testata',
    view: 'Visualizza XML',
    download: 'Scarica XML',
    formats: {
      pretty: 'XML leggibile',
      raw: 'XML originale',
      desadv_20: 'DesAdv 2.0',
      desadv_50: 'DesAdv 5.0',
    },

    // Dettaglio
    detail_title: 'Testata documento {document}',
    header: 'Testata',
    parties: 'Anagrafiche',
    party: {
      seller: 'Fornitore (venditore)',
      buyer: 'Cliente (acquirente)',
      delivery: 'Destinazione merce',
      invoice: 'Destinatario fattura',
    },
    transport: 'Trasporto',
    transport_mode: 'Modalita di trasporto',
    transport_type_code: 'Tipo trasporto',
    free_text: 'Note',
    storage: 'Archiviazione',
    content_hash: 'Hash contenuto',
    response_sequence: 'Sequenza nella risposta',
    ftp_filename: 'File FTP',
    ftp_path: 'Percorso FTP',
    created_at: 'Creato il',
    updated_at: 'Aggiornato il',

    versions_hint:
      'Di questo documento sono state ricevute {count} versioni: qui e mostrata la piu recente',
  },
}

export default teccom
